<template>
  <transition name="viewer-fade">
    <div tabindex="-1" ref="el-image-viewer__wrapper" class="el-image-viewer__wrapper" :class="{ 'case-mode': caseMode, 'qualification-mode': qualificationMode }" :style="{ 'z-index': zIndex }">
      <!--模态层-->
      <div class="el-image-viewer__mask" @click="hide"></div>
      <!-- 工具栏 -->
      <div v-if="showTool" class="el-image-viewer__btn el-image-viewer__actions">
        <div class="el-image-viewer__actions__inner">
          <i class="el-icon-zoom-out" @click="handleActions('zoomOut')"></i>
          <i class="el-icon-zoom-in" @click="handleActions('zoomIn')"></i>
          <i class="el-image-viewer__actions__divider"></i>
          <i :class="mode.icon" @click="toggleMode"></i>
          <i class="el-image-viewer__actions__divider"></i>
          <i class="el-icon-refresh-left" @click="handleActions('anticlocelise')"></i>
          <i class="el-icon-refresh-right" @click="handleActions('clocelise')"></i>
        </div>
      </div>
      <!-- 展示区 -->
      <div v-if="i === index" v-for="(url, i) in urlList" class="el-image-viewer__canvas">
        <!--图片包装器-->
        <div class="el-image-viewer__img-wrapper" :class="{ 'is-horizontal': isHorizontal, 'case-mode-wrapper': caseMode, 'qualification-wrapper': qualificationMode }">
          <!-- 关闭按钮 -->
          <span class="el-image-viewer__btn el-image-viewer__close" :class="{ 'qualification-close': qualificationMode }" @click="hide">
            <i class="el-icon-close"></i>
          </span>
          <!-- 左右切换按钮 -->
          <template v-if="!isSingle">
            <span
              class="el-image-viewer__btn el-image-viewer__prev"
              :class="{ 'is-disabled': !infinite && isFirst }"
              @click="prev">
              <i class="el-icon-arrow-left"/>
            </span>
            <span
              class="el-image-viewer__btn el-image-viewer__next"
              :class="{ 'is-disabled': !infinite && isLast }"
              @click="next">
              <i class="el-icon-arrow-right"/>
            </span>
          </template>
          <!--图片-->
          <img
            ref="img"
            height="788px"
            class="el-image-viewer__img"
            :key="url.img"
            :src="currentImg"
            :style="imgStyle"
            @load="handleImgLoad"
            @error="handleImgError"
            @mousedown="handleMouseDown">
          <!--页数展示-->
          <div v-if="showpage" class="page">
          	{{i+1}}/{{urlList.length}}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { on, off } from 'element-ui/src/utils/dom';
import { rafThrottle, isFirefox } from 'element-ui/src/utils/util';

const Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
};
const mousewheelEventName = isFirefox() ? 'DOMMouseScroll' : 'mousewheel';
export default {
  name: 'pictureView',
  props: {
  	showTool:{//展示工具栏（与分页位置冲突，不可同时使用）
  		type:Boolean,
  		default:false
  	},
  	showpage:{//展示分页
  		type:Boolean,
  		default:false
  	},
    urlList: {//图片数组
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    onSwitch: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    caseMode: {//经典案例模式：白色背景+关闭按钮固定在右上角
      type: Boolean,
      default: false
    },
    qualificationMode: {//公司资质模式：关闭按钮在图片内右上角
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      index: this.initialIndex,
      isShow: false,
      infinite: true,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      },
      scrollPosition: 0,
      isHorizontal: false
    };
  },
  computed: {
    isSingle() {
      return this.urlList.length <= 1;
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.urlList.length - 1;
    },
    currentImg() {
      return this.urlList[this.index].img;
    },
    imgStyle() {
      const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '100%';
      }
      return style;
    }
  },
  watch: {
    index: {
      handler: function(val) {
        this.reset();
        this.onSwitch(val);
      }
    },
    currentImg(val) {
      this.$nextTick(_ => {
        const $img = this.$refs.img[0];
        if (!$img.complete) {
          this.loading = true;
        }
      });
    }
  },
  mounted() {
    this.deviceSupportInstall();
    this.$refs['el-image-viewer__wrapper'].focus();
  },
  methods: {
    hide() {
      this.deviceSupportUninstall();
      this.onClose();
    },
    deviceSupportInstall() {
      this._keyDownHandler = rafThrottle(e => {
        const keyCode = e.keyCode;
        switch (keyCode) {
          // ESC
          case 27:
            this.hide();
            break;
          // SPACE
          case 32:
            this.toggleMode();
            break;
          // LEFT_ARROW
          case 37:
            this.prev();
            break;
          // UP_ARROW
          case 38:
            this.handleActions('zoomIn');
            break;
          // RIGHT_ARROW
          case 39:
            this.next();
            break;
          // DOWN_ARROW
          case 40:
            this.handleActions('zoomOut');
            break;
        }
      });
      this._mouseWheelHandler = rafThrottle(e => {
        e.preventDefault();
        e.stopPropagation();
        const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta > 0) {
          this.handleActions('zoomIn', {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          this.handleActions('zoomOut', {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      on(document, 'keydown', this._keyDownHandler);
      // 使用原生方法以支持 passive: false
      document.addEventListener(mousewheelEventName, this._mouseWheelHandler, { passive: false });

      // 禁用底层页面滚动 - 使用与 NxDepartments 相同的机制
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';
    },
    deviceSupportUninstall() {
      off(document, 'keydown', this._keyDownHandler);
      // 使用原生方法移除监听
      document.removeEventListener(mousewheelEventName, this._mouseWheelHandler);
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;

      // 恢复底层页面滚动 - 使用与 NxDepartments 相同的机制
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      // 恢复滚动位置
      requestAnimationFrame(() => {
        window.scrollTo({
          top: this.scrollPosition,
          behavior: 'instant'
        });
      });
    },
    handleImgLoad(e) {
      this.loading = false;
      // 检测图片是否是横板（宽 > 高）
      const img = e.target;
      if (img.naturalWidth > img.naturalHeight) {
        this.isHorizontal = true;
      } else {
        this.isHorizontal = false;
      }
    },
    handleImgError(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },
    handleMouseDown(e) {
      if (this.loading || e.button !== 0) return;

      const { offsetX, offsetY } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this._dragHandler = rafThrottle(ev => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
      });
      on(document, 'mousemove', this._dragHandler);
      on(document, 'mouseup', ev => {
        off(document, 'mousemove', this._dragHandler);
      });

      e.preventDefault();
    },
    reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    toggleMode() {
      if (this.loading) return;
      const modeNames = Object.keys(Mode);
      const modeValues = Object.values(Mode);
      const index = modeValues.indexOf(this.mode);
      const nextIndex = (index + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      this.reset();
    },
    prev() {
      if (this.isFirst && !this.infinite) return;
      const len = this.urlList.length;
      this.index = (this.index - 1 + len) % len;
    },
    next() {
      if (this.isLast && !this.infinite) return;
      const len = this.urlList.length;
      this.index = (this.index + 1) % len;
    },
    handleActions(action, options = {}) {
      if (this.loading) return;
      const { zoomRate, rotateDeg, enableTransition } = {
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true,
        ...options
      };
      const { transform } = this;
      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    }
  }
};
</script>
<style type="text/css" scoped>
.el-image-viewer__mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(15, 23, 42, 0.7) !important;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border: none !important;
    z-index: 1;
    cursor: pointer;
}
.el-image-viewer__img-wrapper {
    position: relative;
    display: inline-block;
    padding: 0;
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border: none;
    border-radius: 0;
    box-shadow: none;
    max-width: 95vw;
    max-height: 95vh;
    overflow: visible;
}

/* 经典案例模式：白色背景 */
.el-image-viewer__img-wrapper.case-mode-wrapper {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    padding: 16px;
}
.el-image-viewer__btn {
    position: absolute;
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.6);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    transition: all 0.3s ease;
    will-change: transform, box-shadow;
}
.el-image-viewer__next, .el-image-viewer__prev {
    width: 50px;
    height: 50px;
    font-size: 22px;
    color: #fff;
    background: rgba(25, 118, 210, 0.9) !important;
    border-color: rgba(255, 255, 255, 0.8);
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.95;
}
.el-image-viewer__next:hover, .el-image-viewer__prev:hover {
    opacity: 1;
    background: rgba(21, 101, 192, 1) !important;
    transform: translateY(-50%) scale(1.12);
    box-shadow: 0 6px 20px rgba(25, 118, 210, 0.6);
}
.el-image-viewer__close {
    position: absolute;
    top: 0;
    right: 0;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6) !important;
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    flex-shrink: 0;
    z-index: 100;
    margin: 10px 10px 10px 0;
}

.el-image-viewer__close i {
    font-size: 20px;
    color: #fff;
    transition: color 0.3s ease;
}

.el-image-viewer__close:hover {
    background: rgba(239, 68, 68, 0.8) !important;
    border-color: rgba(255, 255, 255, 0.6) !important;
    transform: rotate(90deg) scale(1.1);
}

.el-image-viewer__close:hover i {
    color: #fff;
}
.el-image-viewer__prev {
    left: 5px;
}
.el-image-viewer__next {
    right: 5px;
}
.el-image-viewer__btn.is-disabled {
    opacity: 0.3;
    cursor: not-allowed;
}
.el-image-viewer__img {
    border-radius: 0;
    display: block;
    padding: 0;
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border: none;
    box-shadow: none;
    max-width: 95vw;
    max-height: 95vh;
    object-fit: contain;
}
	.page {
    color: #fff;
    z-index: 10;
    font-size: 32px;
    font-weight: 600;
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  }

  /* PC端展示区样式 - 确保不阻挡遮罩层点击 */
.el-image-viewer__canvas {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    pointer-events: none;
  }

  /* 图片和按钮允许点击事件 */
.el-image-viewer__canvas > *,
.el-image-viewer__btn {
    pointer-events: auto;
  }

/* PC端显示关闭按钮 - 位于图片内右上角 */
@media (min-width: 769px) {
  .el-image-viewer__close {
    display: flex !important;
    position: absolute;
    top: 10px !important;
    right: 10px !important;
    width: 48px;
    height: 48px;
    background: rgba(0, 0, 0, 0.6) !important;
    border: 2px solid rgba(255, 255, 255, 0.6) !important;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    flex-shrink: 0;
    z-index: 100;
    align-items: center;
    justify-content: center;
    margin: 0 !important;
  }

  .el-image-viewer__close i {
    font-size: 22px;
    color: #fff;
    transition: color 0.3s ease;
  }

  .el-image-viewer__close:hover {
    background: rgba(239, 68, 68, 0.8) !important;
    border-color: rgba(255, 255, 255, 0.8) !important;
    transform: rotate(90deg) scale(1.1);
  }

  /* 公司资质模式 - 去掉容器的样式限制，让图片填满容器 */
  .el-image-viewer__img-wrapper.qualification-wrapper {
    padding: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    background: transparent !important;
    border: none !important;
    max-width: 95vw !important;
    max-height: 95vh !important;
  }

  /* 公司资质模式 - 关闭按钮在图片内右上角 */
  .el-image-viewer__close.qualification-close {
    top: 10px !important;
    right: 10px !important;
  }
}

/* 手机端优化 - 图片贴合容器，减少留白 */
@media (max-width: 768px) {
  .el-image-viewer__img {
    border-radius: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    border: none !important;
    box-shadow: none !important;
    max-width: 95vw !important;
    max-height: 85vh !important;
    width: auto !important;
    height: auto !important;
    object-fit: contain !important;
    margin: 0 !important;
    position: relative !important;
  }

  .el-image-viewer__img-wrapper {
    max-width: 100vw !important;
    max-height: 100vh !important;
    padding: 0 !important;
    margin: 0 !important;
    display: inline-block !important;
    position: relative !important;
  }

  .el-image-viewer__canvas {
    height: 100vh !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
  }

  .el-image-viewer__mask {
    background: rgba(0, 0, 0, 0.9) !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
  }

  /* 手机端关闭按钮覆盖在图片右上角 */
  .el-image-viewer__close {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.6) !important;
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
    z-index: 10 !important;
    margin: 8px !important;
  }

  /* 手机端经典案例模式：白色背景 + 关闭按钮固定在右上角 */
  .case-mode .el-image-viewer__img-wrapper.case-mode-wrapper {
    background: #ffffff !important;
    border-radius: 6px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
    padding: 10px !important;
  }

  .el-image-viewer__next,
  .el-image-viewer__prev {
    width: 44px;
    height: 44px;
    background: rgba(0, 0, 0, 0.5) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
  }

  .page {
    font-size: 20px;
    bottom: 20px;
  }
}

@media (max-width: 480px) {
  .el-image-viewer__img {
    border-radius: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    border: none !important;
    box-shadow: none !important;
    max-width: 94vw !important;
    max-height: 86vh !important;
    width: auto !important;
    height: auto !important;
    object-fit: contain !important;
    margin: 0 !important;
    position: relative !important;
  }

  .el-image-viewer__img-wrapper {
    max-width: 100vw !important;
    max-height: 100vh !important;
    padding: 0 !important;
    margin: 0 !important;
    display: inline-block !important;
    position: relative !important;
  }

  .el-image-viewer__canvas {
    height: 100vh !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
  }

  /* 小屏手机关闭按钮覆盖在图片右上角 */
  .el-image-viewer__close {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    width: 36px;
    height: 36px;
    background: rgba(0, 0, 0, 0.6) !important;
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
    z-index: 10 !important;
    margin: 6px !important;
  }

  .el-image-viewer__next,
  .el-image-viewer__prev {
    width: 40px;
    height: 40px;
  }

  .page {
    font-size: 18px;
    bottom: 15px;
  }
}
</style>
